import { useRef, useMemo, useImperativeHandle, } from "react";
let mfaSlotKeyFallbackSeq = 0;
function randomHexFromCryptoGetRandomValues(cryptoObj) {
    const bytes = new Uint8Array(16);
    cryptoObj.getRandomValues(bytes);
    return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}
/**
 * Unique id per input slot for stable React keys. Not used for auth secrets.
 */
function generateSlotKey() {
    const cryptoObj = globalThis.crypto;
    if (cryptoObj && typeof cryptoObj.randomUUID === "function") {
        return cryptoObj.randomUUID();
    }
    if (cryptoObj && typeof cryptoObj.getRandomValues === "function") {
        return randomHexFromCryptoGetRandomValues(cryptoObj);
    }
    // Environments without Web Crypto: monotonic + time is enough for key stability.
    return `mfa-slot-${Date.now()}-${++mfaSlotKeyFallbackSeq}`;
}
/**
 * Stable keys per slot and padded code array (shared web + native).
 */
export function useMfaCodeInputSlots(code, length) {
    const stableSlotKeysRef = useRef([]);
    if (stableSlotKeysRef.current.length !== length) {
        stableSlotKeysRef.current = Array.from({ length }, generateSlotKey);
    }
    const paddedCode = useMemo(() => Array.from({ length }, (_, i) => code[i] ?? ""), [code, length]);
    return { slotKeys: stableSlotKeysRef.current, paddedCode };
}
/**
 * Exposes `focus()` on the first digit input (shared web + native).
 */
export function useMfaCodeInputImperativeFocus(ref, inputRefs) {
    useImperativeHandle(ref, () => ({
        focus: () => {
            inputRefs.current[0]?.focus();
        },
    }));
}
//# sourceMappingURL=mfa-code-input.hooks.js.map